import { render, staticRenderFns } from "./FooterSocialIcons.vue?vue&type=template&id=5678409c"
import script from "./FooterSocialIcons.vue?vue&type=script&lang=js"
export * from "./FooterSocialIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports